export default "__VITE_ASSET__umSw2wUN__"